<template>
  <v-container fluid>
    <v-snackbar v-model="snackbar" :color="snackbarStatus" :timeout="2500">
      {{ snackbarText }}
      <v-btn
        :color="snackbarStatus === 'error' ? 'white' : 'pink'"
        text
        @click="snackbar = false"
        >Cerrar</v-btn
      >
    </v-snackbar>
    <v-snackbar v-model="getError.error" color="error" :timeout="3500">{{
      getError.errorMessage
    }}</v-snackbar>
    <v-dialog v-model="cambiarLogoDialog" persistent max-width="75%">
      <v-card>
        <v-card-title>
          <span class="headline">Editar Imagen</span>
        </v-card-title>
        <v-card-text>
          <div class="d-flex flex-row">
            <div class="d-flex justify-center flex-grow-1 mx-6">
              <v-file-input
                v-model="photoFile"
                color="bolsa-green"
                label="Logo de la Empresa"
                multiple
                accept="image/*"
                placeholder="Selecciona una imagen..."
                prepend-icon="mdi-account-circle"
                @change="mockFunc(photoFile)"
              >
                <template v-slot:selection="{ text }">
                  <v-chip color="bolsa-green" dark label small>{{
                    text
                  }}</v-chip>
                </template>
              </v-file-input>
            </div>
          </div>
          <div class="d-flex flex-row justify-center">
            <div class="d-flex">
              <v-img
                :src="getPhotoUrl"
                :alt="photoFile ? photoFile[0].name : 'alt'"
              />
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="blue"
            text
            @click="cambiarLogoDialog = false"
            :disabled="fetching"
            >Cerrar</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            color="bolsa-green"
            dark
            @click="uploadPhoto"
            :loading="fetching"
            >Guardar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout>
      <v-row>
        <v-col>
          <v-row>
            <v-col cols="12" sm="12" md="4">
              <template>
                <v-card flat>
                  <v-img
                    :src="getImageLogo"
                    :lazy-src="getProfileDefault"
                    max-height="150px"
                    transition="fade-transition"
                    contain
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      class="ma-2"
                      outlined
                      color="blue"
                      @click="cambiarLogoDialog = true"
                    >
                      <v-icon left>mdi-image-edit</v-icon>Editar
                    </v-btn>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </template>
            </v-col>
            <v-col cols="12" sm="12" md="8">
              <template v-if="fetching">
                <v-skeleton-loader
                  type="list-item-three-line"
                ></v-skeleton-loader>
              </template>
              <template v-else>
                <v-list-item three-line>
                  <v-list-item-content>
                    <v-list-item-title class="display-1"
                      >{{ getPerfil.nombres }} {{ getPerfil.apellidoPaterno }}
                      {{ getPerfil.apellidoMaterno }}</v-list-item-title
                    >
                    <v-list-item-subtitle
                      class="text-primary blue--text headline"
                      >{{ getPerfil.cargo }}</v-list-item-subtitle
                    >
                    <v-list-item-subtitle class="headline"
                      >{{ getPerfil.correo }}
                      {{
                        getPerfil.celular ? '| ' + getPerfil.celular : ''
                      }}</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-col>
          </v-row>
          <v-divider class="mt-2"></v-divider>
          <v-row>
            <v-col cols="12" sm="12" md="6">
              <template v-if="fetching">
                <v-skeleton-loader type="article"></v-skeleton-loader>
              </template>
              <template v-else>
                <v-subheader>INFORMACIÓN PRINCIPAL</v-subheader>
                <v-row class="mx-2">
                  <v-col cols="12" sm="2">Empresa:</v-col>
                  <v-col
                    cols="12"
                    sm="10"
                    class="text--secondary font-weight-light"
                    >{{
                      getPerfil.empresa ? getPerfil.empresa.nombreEmpresa : ''
                    }}</v-col
                  >
                </v-row>
                <v-row class="mx-2">
                  <v-col cols="12" sm="2">Sector Industrial:</v-col>
                  <v-col
                    cols="12"
                    sm="10"
                    class="text--secondary font-weight-light"
                    >{{
                      getPerfil.empresa
                        ? getPerfil.empresa.sectorIndustrial
                        : ''
                    }}</v-col
                  >
                </v-row>
                <v-row class="mx-2">
                  <v-col cols="12" sm="2">Dirección:</v-col>
                  <v-col
                    cols="12"
                    sm="10"
                    class="text--secondary font-weight-light"
                    >{{
                      getPerfil.empresa
                        ? getPerfil.empresa.direccion
                          ? getPerfil.empresa.direccion
                          : '-'
                        : '-'
                    }}</v-col
                  >
                </v-row>
                <v-row class="mx-2" v-if="getPerfil.empresa">
                  <v-col cols="12" sm="2">Sitio Web:</v-col>
                  <v-col
                    cols="12"
                    sm="10"
                    class="text--secondary font-weight-light"
                  >
                    <a
                      :href="getPerfil.empresa.sitioWeb"
                      style="text-decoration: none"
                      >{{
                        getPerfil.empresa ? getPerfil.empresa.sitioWeb : ''
                      }}</a
                    >
                  </v-col>
                </v-row>
              </template>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <template v-if="fetching">
                <v-skeleton-loader type="article"></v-skeleton-loader>
              </template>
              <template v-else>
                <template v-if="getPerfil.empresa">
                  <v-subheader>CONTACTO</v-subheader>
                  <v-row class="mx-2">
                    <v-col cols="12" sm="2">Contactos:</v-col>
                    <v-col
                      cols="12"
                      sm="10"
                      class="text--secondary font-weight-light"
                      >{{
                        getPerfil.empresa
                          ? getPerfil.empresa.contactos.length
                            ? getContactos(getPerfil.empresa.contactos)
                            : '-'
                          : '-'
                      }}</v-col
                    >
                  </v-row>
                  <v-row class="mx-2">
                    <v-col cols="12" sm="2">Teléfonos:</v-col>
                    <v-col
                      cols="12"
                      sm="10"
                      class="text--secondary font-weight-light"
                      >{{
                        getPerfil.empresa
                          ? getPerfil.empresa.telefonos.length
                            ? getPerfil.empresa.telefonos.join(', ')
                            : '-'
                          : '-'
                      }}</v-col
                    >
                  </v-row>
                </template>
              </template>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data() {
    return {
      isLoadImg: false,
      transition: 'scale-transition',
      photoFile: null,
      snackbar: false,
      snackbarText: '',
      snackbarStatus: '',
      cambiarLogoDialog: false,
      photoAsUrl: null
    }
  },

  methods: {
    async uploadPhoto() {
      let response = await this.uploadPhotoCompany(this.photoFile[0])
      if (response.success) {
        this.snackbar = true
        this.snackbarStatus = 'Success'
        this.snackbarText = response.message
        await this.fetchPerfilEmpresa()
        this.cambiarLogoDialog = false
        this.photoAsUrl = null
        this.photoFile = null
      }
    },

    getContactos(contactos) {
      return contactos
        .map(function (elem) {
          return elem.nombre + ' - ' + elem.telefono
        })
        .join(', ')
    },

    ...mapActions('company', ['uploadPhotoCompany', 'fetchPerfilEmpresa'])
  },

  computed: {
    getImageLogo() {
      if (this.getPerfil.empresa) {
        return this.getPerfil.empresa.logo
      }
    },

    getProfileDefault() {
      return require('@/assets/empresa.png')
    },

    getPhotoUrl() {
      return this.photoAsUrl
        ? this.photoAsUrl
        : this.getPerfil.empresa
        ? this.getPerfil.empresa.logo
        : this.getProfileDefault
    },

    ...mapGetters('company', ['getPerfil']),
    ...mapGetters('user', ['getError', 'fetching'])
  }
}
</script>

<style>
</style>